module.exports = __webpack_public_path__ + "img/slovenia.d70dcf5d.svg";